// extracted by mini-css-extract-plugin
module.exports = {"component":"index_component__BtQYJ","item":"index_item__n1QIv"};